import React, { useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import styles from "./SecurityPage.module.scss";
import { ResetPasswordModal } from "./modals/reset-password-modal/ResetPasswordModal";
import CustomerPageLayout from "../../customer-page-layout/CustomerPageLayout";
import { ArrowRightIOS } from "../../../../assets/icons";
import CustomerPinModal from "../../components/customer-pin-modal/CustomerPinModal";

interface SecurityItemProps {
	title: string;
	description: string;
	isFirst?: boolean;
	isLast?: boolean;
	onClick?: () => void;
}

const SecurityItem: React.FC<SecurityItemProps> = ({ title, description, isFirst, isLast, onClick }) => (
	<button type="button" className={`${styles.item} ${isFirst ? styles.itemFirst : ""} ${isLast ? styles.itemLast : ""}`} onClick={onClick}>
		<div className={styles.itemContent}>
			<span className={styles.itemTitle}>{title}</span>
			<span className={styles.itemDescription}>{description}</span>
		</div>
		<span className={styles.itemChevron}>
			<ArrowRightIOS />
		</span>
	</button>
);

export const SecurityPage: React.FC = () => {
	const { t } = useTranslation();
	const [showChangePassword, setShowChangePassword] = useState(false);
	const [showChangePin, setShowChangePin] = useState(false);

	const handlePasswordClose = (success?: boolean) => {
		setShowChangePassword(false);
		if (success) toast.success(t("account.web.passwordChangedSuccessfully"));
	};

	const handlePinClose = (result?: string) => {
		setShowChangePin(false);
		if (result === "pinReset") toast.success(t("account.web.transactionPinChangedSuccessfully"));
	};

	return (
		<>
			<CustomerPageLayout title={t("account.security")} showBackButton={true} >
				<div className={styles.card}>
					<SecurityItem
						title={t("common.labels.changePassword")}
						description={t("security.changePasswordDescription")}
						isFirst
						onClick={() => setShowChangePassword(true)}
					/>
					<hr className={styles.divider} />
					<SecurityItem
						title={t("common.labels.changeTransactionPin")}
						description={t("security.changeTransactionPinDescription")}
						isLast
						onClick={() => setShowChangePin(true)}
					/>
				</div>

				{showChangePassword && <ResetPasswordModal onClose={handlePasswordClose} />}
				{showChangePin && <CustomerPinModal initialContent="resetPinContent" onClose={handlePinClose} />}
			</CustomerPageLayout>
		</>
	);
};

export default SecurityPage;
